interface Metric {
  label: string;
  value: string;
  variant?: string;
  size?: string;
  sub?: string;
  subVariant?: string;
}

interface MetricsGridProps {
  metrics: Metric[];
}

const MetricsGrid = ({ metrics }: MetricsGridProps) => {
  return (
    <div className="metrics">
      {metrics.map((metric) => (
        <div className="metric" key={metric.label}>
          <div className="metricLabel">{metric.label}</div>
          <div
            className={`metricVal ${metric.variant || ""} ${metric.size || ""}`.trim()}
          >
            {metric.value}
          </div>
          {metric.sub ? (
            <div className={`metricSub ${metric.subVariant || ""}`.trim()}>
              {metric.sub}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default MetricsGrid;
